"use strict";

function datetimeDiff(from, to) {
    const oneDay = 24 * 60 * 60 * 1000;
    const diffDays = Math.round(Math.abs((to.getTime() - from.getTime()) / (oneDay)));

    return diffDays;
};

export default datetimeDiff;